module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"site-title":"WebPシェアチェッカー","check-webp-share":"WebPシェアをチェック","webp-simulator":"WebP導入シミュレータ"},"en":{"site-title":"WebP Share Checker","check-webp-share":"Create share report","webp-simulator":"WebP Simulator"}}')
  delete Component.options._Ctor
}
